module.exports = __webpack_public_path__ + "static/media/course_05.597e883b.jpg";